import type { AnchorHTMLAttributes, ReactNode } from 'react'
import { isPlainLeftClick, navigate } from './routing'

/**
 * A real anchor with a real `href`, so long-press on iOS offers "Open in new
 * tab" and cmd-click works on a laptop. Only the plain click is taken over.
 */
export function Link({
  to,
  children,
  onClick,
  ...rest
}: { to: string; children: ReactNode } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>) {
  return (
    <a
      href={to}
      {...rest}
      onClick={(event) => {
        onClick?.(event)
        if (!isPlainLeftClick(event)) return
        event.preventDefault()
        navigate(to)
      }}
    >
      {children}
    </a>
  )
}
